import React from "react"
import * as bc from './breadcrumbs.module.scss'

const Breadcrumbs = ({breadcrumbs, pageTitle}) => (

    <ul className={bc.breadcrumbs}>
        <li><a href="/">Home</a></li>
        {breadcrumbs &&
        breadcrumbs.map((breadcrumb, key) => {
            if (breadcrumb !== null) {
                return <li key={key}><a href={breadcrumb.uri}>{breadcrumb.title}</a></li>
            } else {
                return ""
            }
        })
        }
        <li className={bc.bcActive}>{pageTitle}</li>
    </ul>
)

export default Breadcrumbs